<div class="main-hero-div container">
  <div class="hero-img-div">
    <img alt="Hero Image" i18n-alt src="assets/merchant-landing-page/about-us.png" />
  </div>

  <div class="hero-div">
    <div class="hero-title">
      <p class="note" i18n>Who we are?</p>
      <h1 i18n>About us</h1>
      <p i18n>Welcome to Akl Bayti, the premier online marketplace dedicated to bringing gourmet, homemade meals
        straight to food enthusiasts' doors. Our mission is to empower talented home chefs like you by providing a
        platform to showcase your culinary creations, reach a broader audience, and manage your business with ease.
      </p>
    </div>
  </div>
</div>
